import Loading from "components/common/loading";
import NextArrowIcon from "components/icons/NextArrowIcon";
import { useTranslation } from "react-i18next";
import s from "./styles";
import { useBusinessContext } from "../../../BusinessApp";

function ListElement({ text, rightText }) {
  return (
    <div>
      <s.ListWrapper>
        <s.ListText>{text}</s.ListText>
        <s.ListRightElements>
          <s.ListTextBold>{rightText}</s.ListTextBold>
          <NextArrowIcon style={{ marginLeft: "32px" }} />
        </s.ListRightElements>
      </s.ListWrapper>
      <s.Separator />
    </div>
  );
}

function Resume(props) {
  const { t } = useTranslation();
  const { currencyFormat } = useBusinessContext();
  return (
    <s.Container>
      {props.loading ? (
        <Loading height="350px" size="middle" />
      ) : (
        <>
          <s.TopElementContainer>
            <s.Title>{t("containers.Dashboard.Resume.resume")}</s.Title>
            <s.LastDaysText>
              {t("containers.Dashboard.Resume.days")}
            </s.LastDaysText>
          </s.TopElementContainer>
          <ListElement
            text={t("containers.Dashboard.Resume.totalSales")}
            rightText={props.totalSales || "0"}
          />
          <ListElement
            text={t("containers.Dashboard.Resume.totalGains")}
            rightText={`${currencyFormat(props.totalGains)}`}
          />
          <ListElement
            text={t("containers.Dashboard.Resume.soldItems")}
            rightText={props.soldItems || "0"}
          />
          <ListElement
            text={t("containers.Dashboard.Resume.newClients")}
            rightText={props.newClients || "0"}
          />
          <ListElement
            text={t("containers.Dashboard.Resume.monthWorker")}
            rightText={props.monthWorker || "_"}
          />
          <ListElement
            text={t("containers.Dashboard.Resume.mostSoldItem")}
            rightText={props.mostSoldItem || "_"}
          />
        </>
      )}
    </s.Container>
  );
}

export default Resume;
